import React, { useRef } from "react";
import {
  GoogleMap,
  Marker, Polygon, withGoogleMap,
  withScriptjs
} from "react-google-maps";
import { compose, withProps } from "recompose";
import { mapThemeIntelliegence } from "../../../src//assets/map/theme";
import countryMarkerSvg from "../../../src/assets/images/country.svg";
import greenMarker from "../../../src/assets/images/green.svg";
import HoverSvg from "../../../src/assets/images/hover.svg";
import portMarkerSvg from "../../../src/assets/images/port.svg";
import redMarker from "../../../src/assets/images/red.svg";
import { mockMarkerInfo } from "./mockMarkerInfo";

const exampleMapStyles = mapThemeIntelliegence;

const MockMapComponent = () => {
  const mapEnvironment = compose(
    withProps({
      googleMapURL:
        "https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=AIzaSyBt2A7MkqDnWTXzFhNE5qfOySw-3in8aTM",
      loadingElement: <div style={{ height: `100%` }} />,
      containerElement: (
        <div
          style={{
            height: "100vh",
            width: "100%",
            position: "absolute",
            zIndex: 0,
            marginLeft: '-24px',
            marginTop: '-8px',
            overflow: 'hidden'
          }}
          id="map"
        />
      ),
      mapElement: <div style={{ height: `100vh` }} />,
    }),
    withScriptjs,
    withGoogleMap
  );

  const MapLayout = () => {
    const mapRef = useRef(null);

    return (
      <GoogleMap
        ref={mapRef}
        zoom={4}
        defaultCenter={{
          lat: 28.638447245942512,
          lng: 77.22475807605588,
        }}
        defaultOptions={{
          styles: exampleMapStyles,
          maxZoom: 8,
          minZoom: 3,
          fullScreenControl: true,
          mapTypeControl: false
        }}
      >
        {mockMarkerInfo.data.marker_location.map((location, i) => {
          let marker;
          if (location.marker_type === "supplier") marker = greenMarker;
          if (location.marker_type === "news") marker = redMarker;
          if (location.marker_type === "port") marker = portMarkerSvg;
          if (location.marker_type === "country") marker = countryMarkerSvg;
          if (location.marker_type === "news" && location?.hover)
            marker = HoverSvg;
          return (
            <>
              {marker.item_id === "LKCMB" ? (
                <Marker
                  position={{ lat: location.lat, lng: location.lng }}
                  icon={{
                    url: marker,
                  }}
                  key={i}
                  visible={location.marker_visible}
                ></Marker>
              ) : (
                <Marker
                  position={{ lat: location.lat, lng: location.lng }}
                  icon={{
                    url: marker,
                  }}
                  key={i}
                  visible={location.marker_visible}
                ></Marker>
              )}
            </>
          );
        })}
        <Polygon
          path={[
            { lat: 52.52549080781086, lng: 13.398118538856465 },
            { lat: 52.48578559055679, lng: 13.36653284549709 },
            { lat: 52.48871246221608, lng: 13.44618372440334 },
          ]}
          options={{
            fillColor: "#dddddd",
            fillOpacity: 0.1,
            strokeColor: "#00adff",
            strokeOpacity: 1,
            strokeWeight: 2,
          }}
        />
      </GoogleMap>
    );
  };

  const MapComponent = mapEnvironment(MapLayout);

  return (
    <div>
      <MapComponent />
    </div>
  );
};

export default MockMapComponent;
